import { render, staticRenderFns } from "./DataTable.vue?vue&type=template&id=deda1e4e"
import script from "./DataTable.vue?vue&type=script&lang=js"
export * from "./DataTable.vue?vue&type=script&lang=js"
import style0 from "./DataTable.vue?vue&type=style&index=0&id=deda1e4e&prod&lang=scss"
import style1 from "./DataTable.vue?vue&type=style&index=1&id=deda1e4e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports